import { APIResponseWrapper, CB_BASE_PREFIX } from '@/api/types'
import { callBackend } from '@/api/callBackend'
import { ApiMethod } from 'common/src/api/types'
import {
    GetCommentReplyDraftRequest,
    ListCommentReplyDraftsRequest,
    OverrideCommentReplyDraftRequest,
    RecordCommentReplyPostedRequest,
    RedraftCommentReplyDraftRequest,
    SetCommentReplyDraftMutedRequest,
} from 'common/src/api/commentReplyDraft/requests'
import {
    GetCommentReplyDraftResponse,
    ListCommentReplyDraftsResponse,
    OverrideCommentReplyDraftResponse,
    RecordCommentReplyPostedResponse,
    RedraftCommentReplyDraftResponse,
    SetCommentReplyDraftMutedResponse,
} from 'common/src/api/commentReplyDraft/responses'

const PREFIX = `${CB_BASE_PREFIX}/commentDraft/`

export const getCommentReplyDraft = (
    request: GetCommentReplyDraftRequest
): APIResponseWrapper<GetCommentReplyDraftResponse> =>
    callBackend(PREFIX + 'getCommentReplyDraft', ApiMethod.GET, request)

export const listCommentReplyDrafts = (
    request: ListCommentReplyDraftsRequest
): APIResponseWrapper<ListCommentReplyDraftsResponse> =>
    callBackend(PREFIX + 'listCommentReplyDrafts', ApiMethod.GET, request)

export const overrideCommentReplyDraft = (
    request: OverrideCommentReplyDraftRequest
): APIResponseWrapper<OverrideCommentReplyDraftResponse> =>
    callBackend(PREFIX + 'overrideCommentReplyDraft', ApiMethod.POST, request)

export const redraftCommentReplyDraft = (
    request: RedraftCommentReplyDraftRequest
): APIResponseWrapper<RedraftCommentReplyDraftResponse> =>
    callBackend(PREFIX + 'redraftCommentReplyDraft', ApiMethod.POST, request)

export const setCommentReplyDraftMuted = (
    request: SetCommentReplyDraftMutedRequest
): APIResponseWrapper<SetCommentReplyDraftMutedResponse> =>
    callBackend(PREFIX + 'setCommentReplyDraftMuted', ApiMethod.POST, request)

export const recordCommentReplyPosted = (
    request: RecordCommentReplyPostedRequest
): APIResponseWrapper<RecordCommentReplyPostedResponse> =>
    callBackend(PREFIX + 'recordCommentReplyPosted', ApiMethod.POST, request)
